import React, { useState } from 'react';
import moment from 'moment';

import EmptyData from '../../../components/UI/EmptyData';

import './DashboardLeavesTabs.scss';

const TABS = {
  request: 'request',
  approved: 'approved'
};

const formatRange = (start, end) => {
  if (!start || !end) return '—';
  return `${moment(start).format('DD MMM YYYY')} – ${moment(end).format('DD MMM YYYY')}`;
};

const LeaveRows = ({ list }) => {
  if (!list?.length) {
    return (
      <div className="dashboard-leaves-tabs__empty">
        <EmptyData />
      </div>
    );
  }

  return (
    <ul className="dashboard-leaves-tabs__list" role="list">
      {list.map((leave, i) => {
        const user = leave?.userId;
        const key = user?._id || user?.id || `${user?.name || 'leave'}-${i}`;
        return (
          <li key={key} className="dashboard-leaves-tabs__row" role="listitem">
            <div className="dashboard-leaves-tabs__avatar-wrap">
              {user?.profilePicture ? (
                <img className="dashboard-leaves-tabs__avatar" src={user.profilePicture} alt="" />
              ) : (
                <span
                  className="dashboard-leaves-tabs__avatar dashboard-leaves-tabs__avatar--placeholder"
                  aria-hidden
                >
                  {(user?.name || '?').slice(0, 1).toUpperCase()}
                </span>
              )}
            </div>
            <div className="dashboard-leaves-tabs__main">
              <p className="dashboard-leaves-tabs__name">{user?.name || 'Unknown'}</p>
              <p className="dashboard-leaves-tabs__dates">
                {formatRange(leave?.startDate, leave?.endDate)}
              </p>
            </div>
            <div className="dashboard-leaves-tabs__meta">
              <span className="dashboard-leaves-tabs__type">{leave?.leaveType || 'Leave'}</span>
              <span className="dashboard-leaves-tabs__days">
                {leave?.leaveTaken != null
                  ? `${leave.leaveTaken} day${Number(leave.leaveTaken) === 1 ? '' : 's'}`
                  : ''}
              </span>
              {leave?.leaveStatus ? (
                <span className="dashboard-leaves-tabs__status">{leave.leaveStatus}</span>
              ) : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
};

const DashboardLeavesTabs = ({ requestList = [], approvedList = [] }) => {
  const [activeTab, setActiveTab] = useState(TABS.request);

  const requestCount = requestList?.length || 0;
  const approvedCount = approvedList?.length || 0;

  return (
    <div className="card dashboard-leaves-tabs">
      <div className="dashboard-leaves-tabs__top">
        <div className="dashboard-leaves-tabs__title-block">
          <h2 className="dashboard-leaves-tabs__title">Leave</h2>
          <p className="dashboard-leaves-tabs__subtitle">Upcoming in the next 7 days</p>
        </div>
        <div
          className="dashboard-leaves-tabs__segment"
          role="tablist"
          aria-label="Leave requests and approved leave"
        >
          <button
            type="button"
            role="tab"
            id="tab-leaves-request"
            aria-selected={activeTab === TABS.request}
            aria-controls="panel-leaves-request"
            className="dashboard-leaves-tabs__tab"
            onClick={() => setActiveTab(TABS.request)}
          >
            <i className="icofont icofont-paper d-none d-sm-inline" aria-hidden />
            <span className="dashboard-leaves-tabs__tab-text">Pending Leaves</span>
            {requestCount > 0 ? (
              <span className="dashboard-leaves-tabs__count">{requestCount}</span>
            ) : null}
          </button>
          <button
            type="button"
            role="tab"
            id="tab-leaves-approved"
            aria-selected={activeTab === TABS.approved}
            aria-controls="panel-leaves-approved"
            className="dashboard-leaves-tabs__tab"
            onClick={() => setActiveTab(TABS.approved)}
          >
            <i className="icofont icofont-check-circled d-none d-sm-inline" aria-hidden />
            <span className="dashboard-leaves-tabs__tab-text">Approved</span>
            {approvedCount > 0 ? (
              <span className="dashboard-leaves-tabs__count">{approvedCount}</span>
            ) : null}
          </button>
        </div>
      </div>

      <div className="card-body dashboard-leaves-tabs__body">
        <div
          id="panel-leaves-request"
          role="tabpanel"
          aria-labelledby="tab-leaves-request"
          hidden={activeTab !== TABS.request}
          className="dashboard-leaves-tabs__panel"
        >
          {activeTab === TABS.request ? <LeaveRows list={requestList} /> : null}
        </div>
        <div
          id="panel-leaves-approved"
          role="tabpanel"
          aria-labelledby="tab-leaves-approved"
          hidden={activeTab !== TABS.approved}
          className="dashboard-leaves-tabs__panel"
        >
          {activeTab === TABS.approved ? <LeaveRows list={approvedList} /> : null}
        </div>
      </div>
    </div>
  );
};

export default DashboardLeavesTabs;
